// extracted by mini-css-extract-plugin
export default {"item":"uploadItem_item__5+YB0","label":"uploadItem_label__Oz1bS"};